import { formatFileSize } from '@witmetrics/utils/strings';
import type { StagedEntry } from '../types';

export const classes = {
  // Wraps a top-level card and, when a folder is expanded, its nested tree.
  entry: 'flex shrink-0 flex-col',
  children: 'flex flex-col gap-0.5 pl-3 pt-1',
  row: 'my-1 place-between bg-grey-2 dark:bg-white/[0.06] py-2 pl-3 pr-3 text-grey-8 dark:text-mauve-1 shadow-none hover:bg-grey-3 dark:hover:bg-white/[0.1]',
  rowContent: 'place-start min-w-0 grow text-left',
  rowButton: 'cursor-pointer outline-none',
  rowIconWrapper:
    'size-12 shrink-0 place-center rounded-xl bg-white dark:bg-[#332e43] text-blue-3 shadow-card',
  rowIcon: 'size-6',
  rowImg: 'max-h-full max-w-full rounded-lg bg-white dark:bg-[#332e43]',
  rowDetails: 'flex min-w-0 flex-col pl-4 pr-2',
  rowName: 'truncate text-sm text-grey-8 dark:text-mauve-1',
  rowSubtitle: 'text-sm font-light text-grey-6 dark:text-mauve-3',
  removeIcon:
    'close-icon shrink-0 cursor-pointer text-grey-7 dark:text-mauve-2 transition-all text-2xl',
};

export const styles = {
  row: {
    '& .close-icon': { opacity: 0 },
    '&:hover .close-icon': { opacity: 1 },
  },
};

/** A file shows its human-readable size; a folder shows its file count. */
export function getEntrySubtitle(entry: StagedEntry): string {
  if (entry.contents instanceof File)
    return formatFileSize(entry.contents.size);
  return `${entry.fileCount} file${entry.fileCount === 1 ? '' : 's'}`;
}
